module.exports = __webpack_public_path__ + "media/services/smart-finance-icon-f6eb1e44.svg";